module.exports = __webpack_public_path__ + "img/event7.33a5f745.png";